import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/axiosInstance";
import { useToast } from "../../../components/Toast/ToastProvider";
import JobsActionsBar, { jobsBulkBtn } from "../../../components/Jobs/JobsActionsBar";
import { useJobActions } from "../../../components/Jobs/useJobActions";
import JobsTable from "./JobsTable";

const JobsPage = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchJobs = async () => {
    try {
      const response = await api.get("/jobs", { withCredentials: true });
      setJobs(response.data.data || []);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const {
    selectedJobs,
    setSelectedJobs,
    handleBulkAction,
    handleDeleteJob,
    Modals,
  } = useJobActions({ jobs, refresh: fetchJobs });

  const handleCloneJob = (jobId) => {
    const job = jobs.find((j) => j.id === jobId);
    if (!job) return;
    navigate(`/project/${job.project_id}/create-job?clone=${jobId}`);
  };

  const handleEditJob = (jobId) => {
    const job = jobs.find((j) => j.id === jobId);
    if (!job) return;
    navigate(`/project/${job.project_id}/job/${jobId}/edit`);
  };

  const handleExportToExcel = () => {
    // TODO: Implement Excel export
    toast.info("Excel export coming soon.");
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <h1 className="text-2xl font-bold text-gray-900">Jobs</h1>
        <JobsActionsBar
          selectedCount={selectedJobs.length}
          onAction={handleBulkAction}
        >
          <button className={jobsBulkBtn} onClick={handleExportToExcel}>
            Export to Excel
          </button>
        </JobsActionsBar>
      </div>

      {loading ? (
        <div className="flex justify-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-blue-600" />
        </div>
      ) : error ? (
        <p className="text-red-600 text-sm">{error}</p>
      ) : (
        <>
          <p className="text-sm text-gray-600">
            Showing <span className="font-semibold">{jobs.length}</span> items.
          </p>

          <JobsTable
            data={jobs}
            selectedJobs={selectedJobs}
            setSelectedJobs={setSelectedJobs}
            onDelete={handleDeleteJob}
            onClone={handleCloneJob}
            onEdit={handleEditJob}
            onRefresh={fetchJobs}
          />
        </>
      )}

      {Modals}
    </div>
  );
};

export default JobsPage;
